import React from 'react';
import ChangedByCell from './ChangedByCell';
import moment from 'moment';

const widthA = undefined;   // auto stretch

export const CampaignHistoryGridColumnDefinitions = (dateFormat, timeFormat) => {

    // ASSP-8079 Export requires formatted date-time
    const compareDates = (a, b) => {
        const ma = new moment(a, `${dateFormat} ${timeFormat}`);
        const mb = new moment(b, `${dateFormat} ${timeFormat}`);
        if (ma?.isBefore(mb)) return -1;
        if (ma?.isAfter(mb)) return 1;
        return 0;
    }
    
    return [
        {
            field: 'id', visible: false,
        },
        {
            field: 'fieldName', caption: 'Field Name',width: widthA, type: 'string',
        },
        {
            field: 'newValue', caption: 'New Value', width: widthA, type: 'string',
        },
        {
            field: 'oldValue', caption: 'Old Value', width: widthA, type: 'string',
        },
        {
            field: 'changedBy', // ASSP-8079 Export requires simple changedBy field not createdBy object
            // field: 'createdBy',
            caption: 'Changed By',
            cellRender: ({ data }) => 
                <ChangedByCell
                    data={data}
                    field={'createdBy'}
                />
        },
        {
            field: 'changedDate', // ASSP-8079 Export requires formatted date-time
            // field: 'createdDate',
            allowSorting: true,
            width: widthA,
            caption: window.translate('Date & Time'),
            alignment:'right',
            // type: 'datetime',
            // format: `${dateFormat} ${timeFormat}`,
            sort: compareDates
        },
        {
            field: 'campaignVersion', caption: 'Version', width: widthA, type: 'number',
        },
    ];
}

export default CampaignHistoryGridColumnDefinitions;